/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_OUTSTANDING_DISPUTE_QUARTER_DISPLAY =
  'REFRESH_OUTSTANDING_DISPUTE_QUARTER_DISPLAY';
export const SET_SELECTED_OUTSTANDING_DISPUTES_QUARTER =
  'SET_SELECTED_OUTSTANDING_DISPUTES_QUARTER';
export const IS_LOADING_OUTSTANDING_DISPUTES_QUARTER =
  'IS_LOADING_OUTSTANDING_DISPUTES_QUARTER';
export const GET_MANUFACTURER_LIST_OUTSTANDING_DISPUTES_QUARTER =
  'GET_MANUFACTURER_LIST_OUTSTANDING_DISPUTES_QUARTER';
export const GET_OUTSTANDING_DISPUTES_QUARTER_HEADER =
  'GET_OUTSTANDING_DISPUTES_QUARTER_HEADER';
export const GET_OUTSTANDING_DISPUTES_QUARTER =
  'GET_OUTSTANDING_DISPUTES_QUARTER';
export const REFRESH_OUTSTANDING_DISPUTE_QUARTER =
  'REFRESH_OUTSTANDING_DISPUTE_QUARTER';
export const SET_EXPORT_ALL_PDF_OUTSTANDING_DISPUTES_QUARTER =
  'SET_EXPORT_ALL_PDF_OUTSTANDING_DISPUTES_QUARTER';
export const SET_PAGINATION_INDEX_OUTSTANDING_DISPUTES_QUARTER =
  'SET_PAGINATION_INDEX_OUTSTANDING_DISPUTES_QUARTER';
